import { render, staticRenderFns } from "./ProductShortListView.vue?vue&type=template&id=904f38e6&scoped=true"
import script from "./ProductShortListView.vue?vue&type=script&lang=js"
export * from "./ProductShortListView.vue?vue&type=script&lang=js"
import style0 from "./ProductShortListView.vue?vue&type=style&index=0&id=904f38e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904f38e6",
  null
  
)

export default component.exports